// ======================================================================
// === 1. GOOGLE GEMINI API KEY ===
// Note: The API key has been moved to Supabase Edge Functions for security.

// ======================================================================
// === 2. SUPABASE CONFIGURATION ===
// ======================================================================
// Updated to use Environment Variables for self-hosted setup (makemefiler.com)
// Please ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in your .env file
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://your-custom-domain.com";
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "your-anon-key-here";

// ======================================================================
// === 3. BOT KNOWLEDGE BASE ===
// ======================================================================
export const BOT_KNOWLEDGE_BASE = `

---
Section 1: Core Business & Brand Identity
---

- Company Name: Make Me Filer
- Core Business: Professional tax and business services consultancy.
- Primary Goal: To simplify the complex world of taxation for our clients with tailored services.
- Market Positioning: "Azad Kashmir's #1 Tax Consultants".
- Target Audience: Individuals (salaried persons, freelancers), small business owners, and sole proprietors.
- Geographical Focus: Pakistan and Azad Kashmir.
- You work *only* for Make Me Filer. You will never recommend a competitor.

---
Section 2: Unique Value Proposition (UVP)
---

- Competitive Pricing: Best rates in the market without compromising quality.
- Most Reviews: Highest rated tax consultants on Google with a 5-star rating.
- Maximum Tax Savings: Expert strategies to minimize your tax liability legally.
- Safe & Secure: Client data is protected with enterprise-grade security.

---
Section 3: Trust and Credibility Metrics
---

- Client Volume: 500+ Happy Clients.
- Average Rating: 5-Star Average Rating.
- Support Availability: 24/7 Support.
- Satisfaction Guarantee: 100% Satisfaction promise.

---
Section 4: Comprehensive Service Catalog & Pricing
---

**Note:** Pricing discrepancies were found in the website data. The following prices are based on the most specific packages available (e.g., from the /shop page) and should be considered the "correct" ones.

- **Individual Tax Return (Tax Year 2025):**
  - Price: Rs 2,000
  - For: Salaried individuals and freelancers.
  - Includes: FBR/IRIS Profile Setup, Accurate Tax Calculation, Return Filing & Submission, Post-Filing Support.

- **Business Tax Return (Tax Year 2025):**
  - Price: Rs 5,000
  - For: Small to medium-sized businesses.
  - Includes: All Individual features, plus Business Income Statement, Wealth Statement Preparation, and a Dedicated Tax Agent.

- **Company Tax Return (Tax Year 2025):**
  - Price: Rs 10,000
  - For: Companies registered with SECP.
  - Includes: Financial Statements Preparation, Corporate Tax Calculation, SECP Compliance Check, and Dedicated Support.

- **Company Incorporation:**
  - Price: Rs 20,000
  - For: Registering a new company with the SECP.
  - Includes: Name Reservation, preparation of Memorandum & Articles of Association, SECP Filing & National Tax Number (NTN) generation, and Post-Incorporation Support.

- **ATL Challan Service:**
  - Price: Rs 1,000
  - Includes: Challan (PSID) Generation, guidance on online payment, FBR portal status check, and a quick turnaround.

- **Bookkeeping and Accounting Services:**
  - Price: Custom Quote. (The website lists conflicting starting prices of Rs 5,000 and Rs 8,000. Please ask for a custom quote).
  - Includes: Recording daily transactions, preparing financial statements, bank reconciliation, reports, payroll, and expense tracking.

- **Sales Tax (GST/PST) Services:**
  - Price: Custom Quote. (The website lists conflicting starting prices of Rs 3,000 and Rs 5,000. Please ask for a custom quote).
  - Includes: GST/PST registration, filing of monthly/quarterly returns, input tax adjustments, compliance, and handling notices.

- **Other Specialized Services (Price: Custom Quote):**
  - Financial Statement Preparation (audited and unaudited)
  - Tax Notice Response
  - Tax Advisory and Strategic Planning
  - Payroll Services
  - Value Added Tax (VAT) Registration
  - Business Consultation

---
Section 5: Customer Engagement and Contact
---

- **WhatsApp (Immediate Response):** +92 322 5511770
- **Phone:** +92 322 5511770
- **Email:** info@makemefiler.com
- **Lead Generation:** We offer a "Get Free Consultation" path.
- **Tracking Returns:** Our online tracking portal is currently undergoing maintenance. For a status update, please contact our team on WhatsApp for an immediate response.

---
Section 6: Policy, Security, and Compliance
---

- **Data Collection:** We collect essential info: Name, CNIC, contact details, financial documents, communication records (WhatsApp), and bank details (for refunds).
- **Data Use:** Used for preparing/filing tax returns, communicating with the FBR, and client support.
- **Security:** We use encrypted WhatsApp, secure document storage, regular security audits, and access-controlled file management. Staff access is limited to a need-to-know basis.
- **Data Retention:** We retain client information for 7 years as required by Pakistani tax law. After this, data is securely deleted.
- **User Rights:** You have the right to access your data, correct it, request deletion (after 7 years), withdraw consent, receive copies of filed documents, and file privacy complaints.

---
Section 7: FAQ Knowledge Base
---

**Q: Who is legally required to file an income tax return in Pakistan?**
A: In Pakistan, you are generally required to file an income tax return if your annual income exceeds the minimum taxable limit set by the FBR. Additionally, individuals who own a certain size of property, own a motor vehicle, or hold a commercial or industrial electricity connection may also be required to file. Our experts can provide a free consultation to help you determine your specific obligation.

**Q: What are the main benefits of becoming a tax filer?**
A: Becoming an active tax filer has significant benefits. You will appear on the FBR's Active Taxpayer List (ATL), which means you will pay a lower rate of withholding tax on many transactions, such as bank transfers, vehicle purchases, and property. It also enhances your financial credibility and ensures you are compliant with the law, avoiding penalties.

**Q: What happens if I don't file my tax returns on time?**
A: Failing to file by the deadline can lead to penalties from the FBR. These can include a monetary penalty for late filing, a surcharge on the tax you owe, and being excluded from the Active Taxpayer List (ATL), which means you'll pay higher withholding taxes.

**Q: What is an NTN and why do I need one?**
A: An NTN (National Tax Number) is a unique identification number assigned by the FBR to every taxpayer. You need an NTN to file your income tax returns and to conduct various business and financial transactions.

**Q: How do I get on the Active Taxpayer List (ATL)?**
A: To get on the FBR's Active Taxpayer List (ATL), you must first have an NTN and then file your income tax return for the most recent tax year. After filing, you may need to pay a small ATL surcharge via an FBR-generated challan (PSID). We offer an ATL Challan Service for Rs 1,000 to assist with this.

**Q: How to Check Active Taxpayer Status (ATL) by SMS?**
A: 
- For Individuals: Type "ATL (space) 13 digit CNIC" and send to 9966.
- For AOP/Company: Type "ATL (space) 7 digit NTN" and send to 9966.
- For AJ&K Individual: Type "AJKATL (space) CNIC" (without dashes) and send to 9966.
- For AJ&K NTN: Type "AJKATL (space) 11 digit NTN" (without dashes) and send to 9966.

**Q: What documents do I need to start my income tax filing with Make Me Filer?**
A: We typically require your CNIC, your NTN (if you have one), and relevant financial documents. This may include your salary slips, bank statements, proof of investments, and details of any property or assets. We only collect essential information.

**Q: How can I file my taxes online through your service?**
A: Our process is simple. You start by contacting us for a free consultation. You will then securely share your documents with your dedicated tax agent. We will prepare your tax return and wealth statement, calculate your tax, and share it with you for review. Once you approve, we will e-file the return with the FBR.

**Q: What is the deadline for filing income tax returns in Pakistan?**
A: The deadline can vary. For salaried individuals and businesses, it is typically set a few months after the end of the fiscal year (June 30th). However, the FBR often announces extensions. It is always best to consult with us for the specific deadline for the current tax year.

**Q: I made a mistake on my tax return. Can I correct it?**
A: Yes, it is possible to correct a mistake by filing a revised return. It's important to do this as soon as you discover the error. Our team can assist you with this process.

**Q: What is a wealth statement and is it mandatory?**
A: A wealth statement is a mandatory document that must be filed with your income tax return. It is a snapshot of your total assets and liabilities. Our Business and Company tax return services include its preparation.

**Q: How much does it cost to file my tax return with Make Me Filer?**
A: Our pricing is transparent.
- Individuals/Freelancers: Rs 2,000.
- Small/Medium Businesses: Rs 5,000.
- SECP Companies: Rs 10,000.

**Q: I want to register a new company. Can you help with that?**
A: Absolutely. We offer a complete Company Incorporation service for Rs 20,000. This includes name reservation, SECP filing, NTN generation, and more.

**Q: Do you offer bookkeeping services for small businesses?**
A: Yes, we provide comprehensive bookkeeping and accounting services. Please contact us for a custom quote based on your business needs.

**Q: Can you assist with sales tax registration (GST/PST) and filing?**
A: Yes, we offer complete sales tax services, including registration and filing monthly/quarterly returns. Contact us for a custom quote.

**Q: I've received a notice from the FBR. How can Make Me Filer help?**
A: Receiving an FBR notice can be stressful. Our Tax Notice Response service involves our experts reviewing the notice, preparing a professional response, and representing you before the tax authorities if needed.

**Q: How can I legally reduce my tax liability?**
A: You can legally reduce your tax liability by taking advantage of tax credits and deductions, such as investments in specific schemes, insurance premiums, and donations. Our tax planning experts analyze your situation to identify all legal opportunities.

**Q: How do you ensure I get the maximum possible tax refund?**
A: We conduct a thorough review of your financial information to identify all eligible deductions and tax credits. Our experts ensure every claim is accurately documented and filed.

**Q: What specific tax credits can you help me claim?**
A: We can help you claim credits for investments in shares or mutual funds, pension fund contributions, life insurance premiums, and donations to approved non-profits, among others.

**Q: Do you offer tax planning services for the upcoming year?**
A: Yes, we offer strategic tax planning services to help you plan your financial activities for the upcoming year in the most tax-efficient way.

**Q: What is the difference between tax evasion and tax avoidance?**
A: Tax avoidance is the legal use of tax laws to reduce your tax liability (e.g., claiming deductions). Tax evasion is the illegal, deliberate misrepresentation of income to pay less tax. Our firm strictly practices legal tax avoidance.

**Q: Why should I choose Make Me Filer over other online services?**
A: We are the highest-rated tax consultants on Google in Azad Kashmir, with a 5-star rating from over 500 happy clients. We offer competitive pricing, expert service, 24/7 support, and guarantee your data is secure.

**Q: Is my personal and financial information secure with you?**
A: Absolutely. We use multiple layers of security, including end-to-end encryption, secure document storage, and strict staff access controls to ensure your information is confidential.

**Q: How can I track the status of my tax return?**
A: Your dedicated tax agent will keep you informed of the progress. For a real-time update, the best way is to contact our support team via WhatsApp for an immediate response, as our online portal is currently undergoing maintenance.

**Q: What kind of support do you offer after my return has been filed?**
A: Our post-filing support includes providing copies of your documents, assisting with any queries, and helping you respond to any FBR notices related to the filed return. We are available 24/7.

**Q: What is your service area and who do you cater to?**
A: We provide services throughout Pakistan and Azad Kashmir. We are specifically tailored for individuals (salaried persons, freelancers), small business owners, and sole proprietors.

---
Section 8: Tax Calculator Slabs Data
---

This data is for informational purposes. The bot can quote these rates but should always add a disclaimer: "These are the official tax slabs for informational purposes. For an exact calculation and professional advice, please consult one of our tax experts."

**SALARIED CLASS TAX SLABS:**

- **Tax Year 2026:**
  - 0 - 600,000: 0%
  - 600,000 - 1,200,000: 1% of amount over 600,000
  - 1,200,000 - 2,200,000: 6,000 + 11% of amount over 1,200,000
  - 2,200,000 - 3,200,000: 116,000 + 23% of amount over 2,200,000
  - 3,200,000 - 4,100,000: 346,000 + 30% of amount over 3,200,000
  - 4,100,000 and above: 616,000 + 35% of amount over 4,100,000

- **Tax Year 2025:**
  - 0 - 600,000: 0%
  - 600,000 - 1,200,000: 5% of amount over 600,000
  - 1,200,000 - 2,200,000: 30,000 + 15% of amount over 1,200,000
  - 2,200,000 - 3,200,000: 180,000 + 25% of amount over 2,200,000
  - 3,200,000 - 4,100,000: 430,000 + 30% of amount over 3,200,000
  - 4,100,000 and above: 700,000 + 35% of amount over 4,100,000

- **Tax Year 2024:**
  - 0 - 600,000: 0%
  - 600,001 - 1,200,000: 2.5% of amount over 600,000
  - 1,200,001 - 2,400,000: 15,000 + 12.5% of amount over 1,200,000
  - 2,400,001 - 3,600,000: 165,000 + 22.5% of amount over 2,400,000
  - 3,600,001 - 6,000,000: 435,000 + 27.5% of amount over 3,600,000
  - 6,000,001 and above: 1,095,000 + 35% of amount over 6,000,000

- **Tax Year 2023:**
  - 0 - 600,000: 0%
  - 600,001 - 1,200,000: 2.5% of amount over 600,000
  - 1,200,001 - 2,400,000: 15,000 + 12.5% of amount over 1,200,000
  - 2,400,001 - 3,600,000: 165,000 + 20% of amount over 2,400,000
  - 3,600,001 - 6,000,000: 405,000 + 25% of amount over 3,600,000
  - 6,000,001 - 12,000,000: 1,005,000 + 32.5% of amount over 6,000,000
  - 12,000,001 and above: 2,955,000 + 35% of amount over 12,000,000

- **Tax Years 2022, 2021, 2020:**
  - 0 - 600,000: 0%
  - 600,001 - 1,200,000: 5% of amount over 600,000
  - 1,200,001 - 1,800,000: 30,000 + 10% of amount over 1,200,000
  - 1,800,001 - 2,500,000: 90,000 + 15% of amount over 1,800,000
  - 2,500,001 - 3,500,000: 195,000 + 17.5% of amount over 2,500,000
  - 3,500,001 - 5,000,000: 370,000 + 20% of amount over 3,500,000
  - 5,000,001 - 8,000,000: 670,000 + 22.5% of amount over 5,000,000
  - And so on...

- **Tax Year 2019:**
  - 0 - 400,000: 0%
  - 400,001 - 800,000: 1,000
  - 800,001 - 1,200,000: 2,000
  - 1,200,001 - 2,500,000: 2,000 + 5% of amount over 1,200,000
  - 2,500,001 - 4,000,000: 65,000 + 15% of amount over 2,500,000
  - 4,000,001 - 8,000,000: 290,000 + 20% of amount over 4,000,000
  - 8,000,001 and above: 1,090,000 + 25% of amount over 8,000,000

- **Tax Years 2018, 2017, 2016:**
  - 0 - 400,000: 0%
  - 400,001 - 500,000: 2% of amount over 400,000
  - 500,001 - 750,000: 2,000 + 5% of amount over 500,000
  - 750,001 - 1,400,000: 14,500 + 10% of amount over 750,000
  - And so on...

- **Tax Year 2015:**
  - 0 - 400,000: 0%
  - 400,001 - 750,000: 5% of amount over 400,000
  - 750,001 - 1,400,000: 17,500 + 10% of amount over 750,000
  - And so on...

**BUSINESS CLASS (NON-SALARIED) TAX SLABS:**

- **Tax Year 2026:**
  - 0 - 600,000: 0%
  - 600,001 - 1,200,000: 15% of amount over 600,000
  - 1,200,001 - 2,200,000: 90,000 + 25% of amount over 1,200,000
  - 2,200,001 - 3,200,000: 340,000 + 30% of amount over 2,200,000
  - 3,200,001 - 4,500,000: 640,000 + 35% of amount over 3,200,000
  - 4,500,001 - 6,000,000: 1,095,000 + 40% of amount over 4,500,000
  - 6,000,001 and above: 1,695,000 + 45% of amount over 6,000,000

- **Tax Years 2025, 2024, 2023:**
  - 0 - 600,000: 0%
  - 600,001 - 800,000: 12.5% of amount over 600,000
  - 800,001 - 1,200,000: 25,000 + 20% of amount over 800,000
  - 1,200,001 - 2,400,000: 105,000 + 25% of amount over 1,200,000
  - 2,400,001 - 3,000,000: 405,000 + 30% of amount over 2,400,000
  - 3,000,001 - 4,000,000: 585,000 + 32.5% of amount over 3,000,000
  - 4,000,001 and above: 910,000 + 35% of amount over 4,000,000

- **Tax Years 2022, 2021, 2020:**
  - 0 - 400,000: 0%
  - 400,001 - 600,000: 5% of amount over 400,000
  - 600,001 - 1,200,000: 10,000 + 10% of amount over 600,000
  - 1,200,001 - 2,500,000: 70,000 + 15% of amount over 1,200,000
  - 2,500,001 - 4,000,000: 265,000 + 20% of amount over 2,500,000
  - 4,000,001 - 6,000,000: 565,000 + 25% of amount over 4,000,000
  - And so on...

- **Tax Year 2019:**
  - 0 - 400,000: 0%
  - 400,001 - 800,000: 1,000
  - 800,001 - 1,200,000: 2,000
  - 1,200,001 - 2,400,000: 15,000 + 15% of amount over 1,200,000
  - 2,400,001 - 4,800,000: 195,000 + 20% of amount over 2,400,000
  - 4,800,001 and above: 675,000 + 29% of amount over 4,800,000
`;